module.exports = __webpack_public_path__ + "a9780d18b56f75edf4ee3bb5b361d828.png";